import { useEffect, useState } from "react";
import { useWebSocket } from "react-use-websocket/dist/lib/use-websocket";

const socketType = process.env.REACT_APP_SOCKET_TYPE;
const usePing = () => {
  const [successPing, setSuccessPing] = useState(0);
  const [shouldUseWebSocket, setShouldUseWebSocket] = useState(true);

  const { sendJsonMessage, readyState } = useWebSocket(
    socketType !== "iran" ? process.env.REACT_APP_GERMANY_SOCKET_URL : null,
    {
      onOpen: (e) => { },
      //Will attempt to reconnect on all close events, such as server shutting down
      onMessage: (e) => {
        const data = JSON.parse(e.data);

        if (data.id === 11) {
          setSuccessPing((prev) => prev + 1);
        }
      },
      shouldReconnect: (closeEvent) => {
        return true;
      },
      pingTimeout: 1000,
      share: true,
      pingMessage: socketType === "iran" ? undefined : JSON.stringify({
        method: "server.ping",
        params: [],
        id: 11,
      }),
    }
  );


  // چندبار پینگ میفرسته اگه بیشتر از 11 بار جواب بگیره تایید برقراری سوکت میده
  useEffect(() => {
    if (socketType !== "iran") {
      if (readyState === 1) {
        for (let i = 0; i < 20; i++) {
          sendJsonMessage({
            method: "server.ping",
            params: [],
            id: 11,
          });
        }
      } else if (readyState === 3) {
        setShouldUseWebSocket(false);
      }
    }
  }, [readyState]);

  useEffect(() => {
    if (socketType !== "iran") {
      if (successPing > 10) {
        setShouldUseWebSocket(true);
      } else {
        setShouldUseWebSocket(false);
      }
    }
  }, [successPing]);

  return { shouldUseWebSocket };
};
export default usePing;
